
export const SET_MSG = 'TRABALHADOR_MSG';
export const SET_EDITAR = 'TRABALHADOR_EDITAR';
export const SET_LISTA = 'TRABALHADOR_LISTA';
export const SET_LISTAEVENTO = 'TRABALHADOR_LISTAEVENTO';
export const SET_LISTADOCUMENTO = 'TRABALHADOR_LISTADOCUMENTO';
export const SET_MATRICULA = 'TRABALHADOR_MATRICULA';